module.exports = __webpack_public_path__ + "static/media/details__nrg.2ce4d939.svg";